import Config from 'react-native-config';

export const webSocketConfig = {
  baseUrl: Config.WS_URL,
  endpoints: {
    patientPathway: (pathwayId: string) => `/patient/pathway/${pathwayId}`,
  },

  buildUrl: (endpoint: string) => `${webSocketConfig.baseUrl}${endpoint}`,

  getPatientPathwayUrl: (pathwayId: string) =>
    webSocketConfig.buildUrl(webSocketConfig.endpoints.patientPathway(pathwayId)),
} as const;
